import { Loader } from '@pocketlaw/tetris';
import { LoadingContainer } from './styled';
export function LoadingIndicator() {
    return (<LoadingContainer>
      <Loader size={12}/>
    </LoadingContainer>);
}
